import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@utils/auth';

function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/(auth)')({
  beforeLoad: () => {
    // Prevenir loops de redirecionamento
    const redirectKey = 'fila_redirect_in_progress';
    const lastRedirect = sessionStorage.getItem(redirectKey);
    const now = Date.now();

    // Se há redirecionamento em progresso, aguardar
    if (lastRedirect && (now - parseInt(lastRedirect)) < 2000) {
      console.log('🔄 Redirecionamento em progresso, aguardando na rota de auth');
      return;
    }

    // Redirect to dashboard if already authenticated
    if (isAuthenticated()) {
      // Marcar redirecionamento para prevenir loops
      sessionStorage.setItem(redirectKey, now.toString());

      throw redirect({
        to: '/selecionar-estabelecimento',
      });
    }
  },
  component: AuthLayout,
});